import PropTypes from 'prop-types'
import SkeletonComponent from '../../../../../atoms/skeleton'
import {
  textStyleSizeOptions,
  textStyleWeightOptions
} from '../../../../../fundamentals/text-styles/constants'
import { RowText } from '../styled-components'

export const TableRowPathCell = ({ path, isLoading, isError }) => {
  if (isError) return null

  if (isLoading) {
    return (
      <SkeletonComponent
        isLoading
        skeletonShape={{
          width: '96px',
          height: '12px',
          borderRadius: '6px'
        }}
      />
    )
  }

  return (
    <RowText
      weight={textStyleWeightOptions['TEXT-500']}
      size={textStyleSizeOptions['TEXT-XS']}
    >
      {path}
    </RowText>
  )
}

TableRowPathCell.propTypes = {
  path: PropTypes.string,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool
}
